import { AppConfigValuesEnum } from "./constants";
import { AppConfigValue } from "./types";

export const generateAppConfig = (appConfigValues: Array<AppConfigValue>) => {
    const appConfig: any = {};

    appConfigValues?.forEach((configValue: AppConfigValue) => {
        const serverConfigKey = configValue.config_name;
        const appConfigKey = AppConfigValuesEnum[serverConfigKey];

        if (configValue.configuration_type === "JSON") {
            appConfig[appConfigKey] = JSON.parse(configValue.config_value);
        } else {
            appConfig[appConfigKey] = configValue.config_value;
        }
    });

    return appConfig;
};

// A function to update a single configuration value based on matching keys from two objects.
export const updateSingleConfigValue = (
  obj1: { name: string; value: string }, // An object containing the key name and its corresponding value.
  obj2: { [key: string]: string },       // An object mapping key names to their actual keys in the config.
): { [key: string]: string } => {        // Returns an object with the updated key-value pair.

  // Extract the actual key from obj2 using the name from obj1.
  const keyFromObj2 = obj2[obj1.name];

  // If the key is not found in obj2, throw an error indicating the missing key.
  if (!keyFromObj2) {
    throw new Error(`Key ${obj1.name} not found in second object`);
  }

  // Return a new object where the extracted key from obj2 is mapped to the value from obj1.
  return { [keyFromObj2]: obj1.value };
};
